const education = [
  {
    school: "Columbia University",
    date: "Sep 2024 - Aug 2025",
    degree: "MS in Computer Science",
    logo: "/assets/logos/columbia.png"
  },
  {
    school: "University of Florida",
    date: "Aug 2020 - May 2024",
    degree: "BS in Computer Science, Minor in Mathematics",
    logo: "/assets/logos/uf.png"
  }
];

export default education;
